export default __webpack_public_path__ + "static/media/Surprise Page.50d8274d.jpg";